import PropTypes from 'prop-types'
import React from 'react'
import { getMergedClassNames } from '../../../../utils/HTMLutils'
import './TextEditorMenuButton.scss'
const rootClassName = 'text-editor-menu-button'

export default function TextEditorMenuButton(props) {
  return (
    <button
      {...props}
      className={getMergedClassNames([props.className || '', rootClassName])}
    />
  )
}

TextEditorMenuButton.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool
}
